import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { StudentOs, StudentEsa, ProgramType, ResendAwardOfferResponse, ScholarshipApplicationPrint } from '@k12/models';
import { SHARED_ENVIRONMENT } from '@k12/app-services';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class StudentAwardService {
  private readonly http = inject(HttpClient);
  private readonly sharedEnvironment = inject(SHARED_ENVIRONMENT);
  private readonly apiUrl = this.sharedEnvironment.adminApiUrl;

  getOs(studentId: string, academicYearId: number | null): Observable<StudentOs> {
    const params: Record<string, string | number> = {};
    if (academicYearId !== null) {
      params['academicYearId'] = academicYearId;
    }
    return this.http.get<StudentOs>(`${this.apiUrl}/household/student/${studentId}/os`, { params });
  }

  saveOsStudentDetail(studentId: string, payload: StudentOs): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/household/student/${studentId}/os`, payload);
  }

  getEsa(studentId: string, academicYearId: number | null): Observable<StudentEsa> {
    const params: Record<string, string | number> = {};
    if (academicYearId !== null) {
      params['academicYearId'] = academicYearId;
    }
    return this.http.get<StudentEsa>(`${this.apiUrl}/household/student/${studentId}/esa`, { params });
  }

  saveEsaStudentDetail(studentId: string, payload: StudentEsa): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/household/student/${studentId}/esa`, payload);
  }

  resendAwardOffer(studentId: string, programType: ProgramType): Observable<ResendAwardOfferResponse> {
    const code: 'ESA' | 'OS' = programType === ProgramType.ESA ? 'ESA' : 'OS';
    return this.http.post<ResendAwardOfferResponse>(
      `${this.apiUrl}/household/student/${studentId}/resend-award-offer`,
      null,
      { params: { programTypeCode: code } }
    );
  }

  public getScholarshipApplicationPrint(studentId: string,programType: ProgramType): Observable<ScholarshipApplicationPrint> {
    const code: 'ESA' | 'OS' = programType === ProgramType.ESA ? 'ESA' : 'OS';
    return this.http
    .get<{ entity: ScholarshipApplicationPrint }>(
      `${this.apiUrl}/student/${studentId}/application/print/${code}`
    )
    .pipe(map((response) => response.entity));
  }
}
